import React, { Component } from "react";
import Navbar from "react-bootstrap/lib/Navbar";
import { node, shape, string } from "prop-types";
import { NavbarProvider } from "./NavbarProvider";

class Header extends Component {
    static propTypes = {
        children: node.isRequired,
        addClassName: string,
        className: string,
        styleOther: shape({}),
    };

    static defaultProps = {
        addClassName: "",
        className: "",
        styleOther: {},
    };

    state = {
        expanded: false,
    };

    onToggle = (expanded) => {
        this.setState({ expanded });
    };

    render() {
        const { addClassName, children, className, styleOther } = this.props;
        const { expanded } = this.state;

        return (
            <header style={styleOther} className={`view-header ${className}`}>
                <Navbar collapseOnSelect fluid onToggle={this.onToggle}>
                    <Navbar.Header className={`toolbar ${addClassName}`}>
                        <NavbarProvider value={{ expanded }}>{children}</NavbarProvider>
                    </Navbar.Header>
                </Navbar>
            </header>
        );
    }
}

export default Header;
